<!--
     Copyright (c) 2025 Broadcom. All Rights Reserved.
     Broadcom Confidential. The term "Broadcom" refers to Broadcom Inc.
     and/or its subsidiaries.
-->
<div *ngIf="icon" class="icon-box">
    <cds-icon [attr.shape]="icon"
              [size]="iconSize">
    </cds-icon>
</div>
<label>
    {{ label }}
</label>
